import { formatRound, formatTruncate } from './NumberFormatter';
const MAX_PRECISION_ON_SERVER = 8;
export function formatTruncatePriceByVariableTickSize(instrument, price) {
    const precision = instrument.getPrecision(price);
    return formatTruncate(price, precision);
}
export function formatRoundPriceByVariableTickSize(instrument, price) {
    const precision = instrument.getPrecision(price);
    return formatRound(price, precision);
}
export function formatTruncatePrice(instrument, price) {
    const precision = instrument.getDefaultPrecision();
    return formatTruncate(price, precision);
}
export function formatRoundPrice(instrument, price) {
    const precision = instrument.getDefaultPrecision();
    return formatRound(price, precision);
}
export function formatTruncatePriceByMaxPrecision(price) {
    return formatTruncate(price, MAX_PRECISION_ON_SERVER);
}
export function formatRoundPriceByMaxPrecision(price) {
    return formatRound(price, MAX_PRECISION_ON_SERVER);
}
